module.exports = __webpack_public_path__ + "static/fonts/TUV-Montserrat-Bold.d24e393.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/TUV-Montserrat-Bold.ttf
// module id = 9Jux
// module chunks = 0